// Импортируем массив проектов
import { projectsData } from "../data/projectsData";
import { projectsTranslations } from "../data/projectsTranslations";
import { getLanguage } from "../data/language";

export function renderProjects() {
  const container = document.querySelector("#projects-container");
  if (!container) return;

  const lang = getLanguage();
  const t = projectsTranslations[lang]?.links || {};

  // Вложенный цикл/генерация для массива ссылок-кнопок
  container.innerHTML = projectsData
    .map((project, index) => {
      const { title, description, image, imageClass, links } = project;

      const linksHtml = links
        .map(({ text, className, url }) => {
          const linkText = t[text] || text;
          return `
            <a rel="noreferrer" target="_blank" class="cta-btn ${className}" href="${url}" data-project-link="${text}">
              ${linkText}
            </a>
          `;
        })
        .join("");

      const titleText = title[lang] || title["ru"];
      const descText = description[lang] || description["ru"];
      // Возвращаем собранную строку проекта
      return `
        <div class="row" data-project-id="${index}">
          <div class="col-xl-4 col-sm-12">
            <div class="project-wrapper__text load-hidden">
              <h3 class="project-wrapper__text-title" data-project-title>${titleText}</h3>
              <div>
                <p class="mb-4" data-project-desc>${descText}</p>
              </div>
              ${linksHtml}
            </div>
          </div>
          <div class="col-xl-8 col-sm-12">
            <div class="project-wrapper__image load-hidden">
              <div
                data-tilt
                data-tilt-max="4"
                data-tilt-glare="true"
                data-tilt-max-glare="0.5"
                class="thumbnail js-tilt ${imageClass || ""}"
              >
                <img alt="Project Image" class="img-fluid" src="${image}" />
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join("");
}

export function updateProjectLinks() {
  const container = document.querySelector("#projects-container");
  if (!container) return;

  const lang = getLanguage();
  const t = projectsTranslations[lang]?.links || {};

  // Обновление ссылок
  container.querySelectorAll("[data-project-link]").forEach((link) => {
    const originalText = link.getAttribute("data-project-link");
    link.textContent = t[originalText] || originalText;
  });

  // Обновление текстового контента карточек
  projectsData.forEach(({ title, description }, index) => {
    const projectRow = container.querySelector(`[data-project-id="${index}"]`);
    if (!projectRow) return;

    const titleEl = projectRow.querySelector("[data-project-title]");
    const descEl = projectRow.querySelector("[data-project-desc]");

    if (titleEl) titleEl.textContent = title[lang] || title["ru"];
    if (descEl) descEl.innerHTML = description[lang] || description["ru"];
  });
}